var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 row"},[_c('div',{ref:"textPost",class:{
      'col-12 pt-3 px-0': true,
      'text': !_vm.showing,
      'text-open': _vm.showing
    },domProps:{"innerHTML":_vm._s(_vm.text)}}),(_vm.showMore)?_c('div',{staticClass:"bg-akdemica show-more col-12 text-center small text-white",on:{"click":_vm.toggleShow}},[(!_vm.showing)?_c('span',[_c('span',{staticClass:"fa fa-caret-down"}),_vm._v(" Ver Mais")]):_c('span',[_c('span',{staticClass:"fa fa-caret-up"}),_vm._v(" Ver Menos")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }